import HtmlParser from '../HtmlParser';
import style from './index.module.less';


interface propsTypes {
  title: string;
  desc: string;
  children?: React.ReactNode;
}

export default function PartTitle(props: propsTypes) {
  const {title, desc, children} = props;
  return (
    <div data-exam-surface className={`${style.main} mb-2`}>
      <div className={style.left}>
        <div data-exam-text-size="28" className={style.title} data-key="title"><HtmlParser htmlString={title}></HtmlParser></div>
        <div className={style.desc} data-key="desc"><HtmlParser htmlString={desc}></HtmlParser></div>
      </div>
      {
        children ? <div className={style.right}>{children}</div> : null
      }
    </div>
  );
}
